<div class="loader-overlay">
    <div class="loader">
      <img
      src="./assets/img/logo2.svg"
      [routerLink]="['']"
      class="logo"
      alt="logo"
    />
    </div>
  </div>